<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.cancel_license')}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('scope.auth')" :count="params.data.length" :action="$t('scope.cancel_license')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form-model ref="form" :model="form" :rules="rules" v-bind="formItemLayout">
        <a-form-model-item :label="$t('common.reason')" prop="cancelled_reason">
          <a-input v-model="form.cancelled_reason" :placeholder="$t('common.tips.input', [''])" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'CancelLicenseDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        cancelled_reason: '',
      },
      rules: {
        cancelled_reason: [{ required: true, message: this.$t('common.tips.input', [this.$t('common.reason')]) }],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.params.onManager('performAction', {
          id: this.params.data[0].id,
          managerArgs: {
            action: 'cancel',
            data: {
              reason: this.form.cancelled_reason,
            },
          },
        })
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
